export const Navigation = ({ openMenu }: { openMenu: () => void }) => {
  return (
    <div className="flex h-16 bg-white">
      <div className="flex w-full justify-between items-center px-4 shadow-xl">
        <div>
          <div className="flex items-center text-blue-600">
            <i className="fa fa-guitar fa-2x mr-2 text-yellow-600" />
            <h1 className="font-sans text-xl sm:text-2xl font-extrabold">
              Nap Poet Pin
            </h1>
          </div>
        </div>
        <div className="flex items-center">
          <div onClick={openMenu}>
            <i className="fa fa-paw fa-2x text-yellow-600 hover:text-yellow-500 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
  );
};
